import { Menu, MenuItem } from '@mui/material';

const TextTemplateMenu = ({ contextMenu, templates, onClose, onSelect }) => {
  return (
    <Menu
      open={contextMenu !== null}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
    >
      {templates.length === 0 && <MenuItem disabled>Nincs választható sablon</MenuItem>}
      {templates.map((template) => (
        <MenuItem key={template.id} onClick={() => onSelect(template)}>
          {template.name}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default TextTemplateMenu;
